import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

const AlertDialog = ({
  type = "error",
  title = "Alert",
  message = "Something happened.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  open = false,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  const styles = {
    error: {
      icon: <ExclamationTriangleIcon className="size-6 text-red-400" />,
      iconBg: "bg-gray-600",
      buttonBg: "bg-red-400 hover:bg-red-500",
    },
    success: {
      icon: <CheckCircleIcon className="size-6 text-blue-400" />,
      iconBg: "bg-gray-600",
      buttonBg: "bg-blue-400 hover:bg-blue-500",
    },
  };

  const { icon, iconBg, buttonBg } = styles[type] || styles.error;

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[20000]">
      <DialogBackdrop className="fixed inset-0 bg-gray-600/75 transition-opacity" />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel className="relative transform overflow-hidden rounded-lg bg-gray-700 px-4 pb-4 pt-5 shadow-xl transition-all sm:max-w-lg sm:p-6 border border-gray-600">
            <div className="absolute right-0 top-0 pr-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="rounded-md text-gray-400 hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <XMarkIcon className="size-5" />
              </button>
            </div>
            <div className="sm:flex sm:items-start">
              <div
                className={`mx-auto flex size-10 shrink-0 items-center justify-center rounded-full ${iconBg} sm:mx-0`}
              >
                {icon}
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle
                  as="h3"
                  className="text-lg font-semibold text-white"
                >
                  {title}
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-200">{message}</p>
                </div>
              </div>
            </div>
            <div className="mt-4 sm:flex sm:flex-row-reverse sm:gap-3">
              <button
                type="button"
                onClick={() => {
                  onConfirm?.(); // run any custom logic if you ever pass it
                  onClose(); // ← THIS WAS MISSING – now it always closes
                }}
                className={`inline-flex w-full justify-center rounded-md ${buttonBg} px-4 py-2 text-sm font-semibold text-gray-200 shadow-sm sm:w-auto transition-colors duration-200`}
              >
                {confirmText}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex w-full justify-center rounded-md bg-gray-600 px-4 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-gray-500 hover:bg-gray-500 sm:w-auto transition-colors duration-200"
              >
                {cancelText}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AlertDialog;
